import React from 'react';
import { Text, View } from 'react-native';

import ProgressIndicatorSwitcher, {
  ProgressIndicatorProps,
} from './ProgressIndicatorSwitcher';
import QuestionMarker from './QuestionMarker';
import { IQuestionItem, IQuestionnaire } from '@nocode/types';

const QuestionHeader = ({
  canvas,
  configs,
  currentIndex,
  styleConfig,
  questions,
}: {
  canvas: boolean;
  configs: IQuestionnaire['configs'];
  currentIndex: number;
  styleConfig: IQuestionnaire['style'];
  questions: IQuestionItem[];
}) => {
  return (
    <>
      <QuestionMarker
        questionMarker={configs.questionMarker}
        index={currentIndex}
        styleConfig={styleConfig}
      />
      <Text
        style={{
          fontWeight: '700',
          marginVertical: 16,
          marginHorizontal: 20,
          color: styleConfig.question?.color || '#1A2737',
          fontFamily: styleConfig.fontFamily as string,
          fontSize: styleConfig.question?.fontSize || 24,
        }}
      >
        {questions[currentIndex]?.question}
      </Text>
      <View style={{ marginHorizontal: 20, marginBottom: 40 }}>
        <ProgressIndicatorSwitcher
          variant={
            (configs.progressBar?.variant ||
              'default') as ProgressIndicatorProps['variant']
          }
          progress={canvas ? 1 : currentIndex + 1}
          total={questions.length}
          styleConfig={styleConfig}
        />
      </View>
    </>
  );
};

export default QuestionHeader;
